import { formatMoney } from 'utils';
class ProductDetailTopAddToCart extends HTMLElement {
  constructor() {
    super();
    $('product-detail-top--add-cart .variant-selector').select2({
      minimumResultsForSearch: Infinity,
    });
    this.init();
  }
  init() {
    this.productId = $(this).data('product-id');
    this.variantData = this.getVaniantData();

    this.optionsDom = $(this).find('.variant-selectors select');
    this.currentVariant = this.getCurrentVariant();
    this.quantityInput = $(this).find('quantity-input').first();
    this.addOptionsChangeEvent();
    $(this)
      .find('.cus_choose')
      .on('click', e => {
        this.showbottomPop();
      });
    $(this)
      .find('.close')
      .on('click', e => {
        this.closeBottomPop();
      });
  }
  // 获取变体数据
  getVaniantData() {
    // 如果已经存在变体数据，则直接返回
    if (this.variantData) {
      return this.variantData;
    }
    // 获取产品变体json数据
    const dom = $(`#ProductVariantJson-${this.productId}[type="application/json"]`).first();
    // 如果存在变体数据，则解析并返回
    if (dom) {
      return (this.variantData = JSON.parse(dom.text()));
    }
    // 如果不存在变体数据，则返回空数组
    return [];
  }
  // 添加选项更改事件
  addOptionsChangeEvent() {
    const _this = this;
    this.quantityInput.on('update', function () {
      const val = $(this).val();
      $(_this).find('input[name="quantity"]').first().val(val);
    });
    this.optionsDom.on('change', e => {
      this.getCurrentVariant();
      this.updateCurrentVariant();
      this.updatePrice();
      this.updateImg();
    });
  }

  // 获取当前变体
  getCurrentVariant() {
    const optionsDom = $(this).find('.variant-selectors select');
    this.options = Array.from(optionsDom).map(item => $(item).val());
    const variant = this.variantData.find(item => {
      return item.options.every((option, index) => option === this.options[index]);
    });
    this.currentVariant = variant;
  }
  // 更新当前变体id
  updateCurrentVariant() {
    if (this.currentVariant) {
      $(this).find('input[name="id"]').val(this.currentVariant.id);
    }
  }
  updatePrice() {
    const price = formatMoney(this.currentVariant.price, window.theme.money_product_price_format);
    const comparePrice = formatMoney(
      this.currentVariant.compare_at_price,
      window.theme.money_product_price_format,
    );
    $(this).find('.price').text(price);
    $(this).find('.compare-price').text(comparePrice);
  }
  showbottomPop() {
    $(this).find('.mask').css('display', 'block');
    $(this).find('.product-form__bottom').css('display', 'block');
    $('body').eq(0).addClass('u-scroll-disabled');
  }
  closeBottomPop() {
    $(this).find('.mask').css('display', 'none');
    $(this).find('.product-form__bottom').css('display', 'none');
    $('body').eq(0).removeClass('u-scroll-disabled');
  }
  updateImg() {
    if (this.currentVariant.featured_image) {
      $(this).find('.cus-product-image').attr('src', this.currentVariant.featured_image.src);
    }
  }
}
$(document).ready(function () {
  customElements.define('product-detail-top--add-cart', ProductDetailTopAddToCart);
});
